import { z } from 'zod';

export const DeskingEquipmentFormPartSchema = z.object({
  equipment: z.object({
    year: z.string(),
    make: z.string(),
    model: z.string(),
    class: z.string(),
    stockId: z.string(),
    newUsed: z.string(),
    mileage: z.number(),
    quantity: z.string(),
    description: z.string(),
    retailPrice: z.number(),
    serialNumberVin: z.string(),
    totalWholesaleCost: z.number(),
    selectedEquipment: z.string().uuid().nullable(),
  }),
});
